var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ReactDOM = require("react-dom");
var Component_1 = require("../Component");
var Spinner_1 = require("./Spinner");
var prefixClassName = 'w--button';
var Button = (function (_super) {
    __extends(Button, _super);
    function Button(props) {
        return _super.call(this, props) || this;
    }
    Button.prototype.handleClick = function (evt) {
        var _a = this.props, customValueAttr = _a.customValueAttr, onClick = _a.onClick;
        onClick && onClick(evt, customValueAttr);
    };
    Button.prototype.focus = function () {
        !this.props.disabled &&
            ReactDOM.findDOMNode(this.refs.button).focus();
    };
    Button.prototype.render = function () {
        var _this = this;
        var _a = this.props, title = _a.title, _b = _a.type, type = _b === void 0 ? '' : _b, _c = _a.customClass, customClass = _c === void 0 ? '' : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, disableOnLoading = _a.disableOnLoading, theme = _a.theme;
        var themeClassName = theme ? prefixClassName + "--" + theme : '';
        var className = prefixClassName + " " + customClass + " " + type + " " + themeClassName;
        var tooltip = typeof title == 'string' ? title.toString() : '';
        var isLoading = type === 'loading';
        var isDisabled = disabled || (disableOnLoading && isLoading);
        return (React.createElement("button", { ref: function (ref) { return (_this.button = ref); }, disabled: isDisabled, title: tooltip, onClick: isDisabled ? null : this.handleClick.bind(this), className: className }, isLoading ? React.createElement(Spinner_1.default, null) : title));
    };
    Button.defaultProps = {
        title: 'Submit',
        disableOnLoading: false,
    };
    return Button;
}(Component_1.default));
exports.default = Button;
